export default __webpack_public_path__ + "static/media/chart-error.66e6cf01.png";